(() => {
  if (/^\/collections\/beds\/browse-bed-daybed\/?$/.test(location.pathname)) {
    const target = new URL(location.href);
    target.pathname = '/collections/daybeds/browse-daybed-indoor';
    location.replace(target.href);
    return;
  }
  // Preserve old shared size URLs while routing to exact item/variant-derived categories.
  const match = location.pathname.match(/^\/collections\/beds\/filter-size-(king|queen|full|twin|california-king)\/?$/);
  if (match) {
    const target = new URL(location.href);
    target.pathname = '/collections/beds/browse-bed-' + match[1];
    location.replace(target.href);
  }
})();
